module.exports = "<ul>\n<% _.each(data, function (d) { %>\n  <li value=\"<%= d.id %>\"><%= d.text %></li>\n<% }) %>\n</ul>";
